import { SearchBarPickerModeEnum } from './search-bar-picker.enum'

export const getSearchBarPickerClassNameByEnum = (
  searchBarPickerModeEnum: SearchBarPickerModeEnum,
): string => {
  switch (searchBarPickerModeEnum) {
    case SearchBarPickerModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}
